import { render, staticRenderFns } from "./indexyewubankuaiNew.vue?vue&type=template&id=1f2fafb1&scoped=true"
import script from "./indexyewubankuaiNew.vue?vue&type=script&lang=js"
export * from "./indexyewubankuaiNew.vue?vue&type=script&lang=js"
import style0 from "./indexyewubankuaiNew.vue?vue&type=style&index=0&id=1f2fafb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2fafb1",
  null
  
)

export default component.exports